import { toast } from "react-toastify";
import { css } from "glamor";
import React from "react";
import success from "@safecv/assets/Images/success.png";
import failure from "@safecv/assets/Images/failure.png";
import info from "@safecv/assets/Images/enhancedsearchinfo.svg";

import "./toast.css";

function setHTML(imageSource, msg) {
  return (
    <div className="parentToast">
      <div className="status">
        <img className="statusImage" src={imageSource} alt="cancel"></img>
      </div>
      <p className="msg">{msg}</p>
    </div>
  );
}

export default {
  success(msg, options = {}) {
    //toast.dismiss();
    return toast.success(setHTML(success, msg), {
      ...options,
      position: toast.POSITION.BOTTOM_LEFT,
      hideProgressBar: true,
      toastId: 1,
      className: "toast-success-container toast-success-container-after",
      progressClassName: css({
        background: "#F0FFF4",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
      }),
    });
  },
  error(msg, options = {}) {
    //toast.dismiss();
    return toast.error(setHTML(failure, msg), {
      ...options,
      position: toast.POSITION.BOTTOM_LEFT,
      hideProgressBar: true,
      toastId: 1,
      className: "toast-error-container toast-error-container-after",
      progressClassName: css({
        background: "#F0FFF4",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
      }),
    });
  },
  info(msg, options = {}) {
    return toast.info(setHTML(info, msg), {
      ...options,
      position: toast.POSITION.BOTTOM_LEFT,
      hideProgressBar: true,
      toastId: 1,
      className: "toast-info-container toast-info-container-after",
      progressClassName: css({
        background: "#F0FFF4",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
      }),
    });
  },
};
